
export function log(componentName, ...message) {
    if (process.env.REACT_APP_ENV == "staging" || window.debugenabled) {
        console.log(componentName, message);
    }
}